// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__AePO2","textarea":"styles_textarea__1__d1"};